import type { UserData } from "@services/api/authentication/currentUser/interface";
import { createContext, useContext } from "react";

export type AuthContextValue = {
  user: UserData | null;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (!context) {
    return { user: null }
  }

  return context;
}
